/**
 * Slovník CZ – převzato z objektu `T` v prototypu, doplněno o klíče,
 * které prototyp neměl (přihlášení, skenování, chybové stavy, offline).
 *
 * Tento soubor je zdroj pravdy pro typ `TKey`; ostatní jazyky musí mít
 * stejnou sadu klíčů, jinak neprojde `tsc`.
 */
export const cs = {
  // app bar
  app: 'Sklad',
  logoutA: 'Odhlásit se',

  // karta
  idLbl: 'Číslo zásilky',
  seq: 'Pořadí',
  nav: 'Navigovat',
  count: 'Počet balíků',
  weight: 'Váha',
  edit: 'Upravit',
  date: 'Datum',
  driver: 'Řidič',
  vehicle: 'Vozidlo',
  zone: 'Zóna',
  routeNo: 'Číslo trasy',
  deliveryTime: 'Čas',
  scanned: 'Naskenovaný kód',
  scannedBy: 'Načteno skladem',
  noWeight: '— kg',
  addWeight: 'Doplnit váhu',

  // okno s datem
  until: 'Bude doručováno až',
  dayLbl: 'Den doručení',
  notSet: 'Ještě neurčen',
  expedFrom: 'Bude expedováno ze skladu',

  // teplotní režim
  chill: 'CHLAZENÉ',
  frozen: 'MRAŽENÉ',

  // převoz
  trCZ: 'ODESLAT DO ČR',
  trSK: 'ODESLAT DO SR',
  trNoteCZ: 'Zásilku nutno převézt do ČR.',
  trNoteSK: 'Zásilku nutno převézt do SR.',
  loadToday: 'NALOŽIT DNES',
  confirmTr: 'Potvrdit převoz',
  trValCZ: 'Převezeno do ČR',
  trValSK: 'Převezeno do SR',
  confirmTitle: 'Potvrdit převoz mezi sklady',
  confirmNote: 'Potvrzením se do objednávky zapíše: „{W}“.',
  notFinal: 'Není to konečný stav.',

  // kompletace
  pkgLbl: 'Balík',
  ofN: 'z',
  kompLbl: 'Kompletace objednávky',
  kompDone: 'ZÁSILKA KOMPLETNĚ NASKENOVÁNA',
  kompTodo: 'NUTNO JEŠTĚ NASKENOVAT',

  // příznaky
  retry: 'Opakovaný pokus',
  part: 'Doručit druhou část',

  // akce
  scanNext: 'Skenovat další',
  report: 'Nahlásit DISPEČERŮM',
  reported: 'Nahlášeno dispečerům',
  findManual: 'NAJÍT MANUÁLNĚ',

  // dialog hlášení
  reportTitle: 'Nahlásit dispečerům',
  reasonLbl: 'Důvod',
  byState: 'PODLE STAVU',
  r_zrusena: 'Zásilka je již zrušená',
  r_dorucena: 'Zásilka je již doručená',
  r_vracena: 'Zásilka je již vrácena odesílateli',
  r_jiny: 'Jiný důvod – popiš v poznámce',
  noteReq: 'Poznámka (povinná)',
  noteOpt: 'Poznámka (nepovinná)',
  notePh: 'Např. balík je poškozený, štítek nečitelný…',
  send: 'Odeslat hlášení',
  sending: 'Odesílám…',
  cancel: 'Zrušit',
  errReason: 'Vyber důvod hlášení.',
  errNote: 'U jiného důvodu doplň poznámku.',

  // dialog manuálního hledání
  findTitle: 'Najít manuálně',
  orderNo: 'Číslo objednávky',
  orderPh: 'Zadej číslo objednávky',
  search: 'Hledat',
  searching: 'Hledám…',
  errQuery: 'Zadej číslo objednávky.',

  // přihlášení
  loginTitle: 'Přihlášení',
  loginSubtitle: 'Přihlas se pro pokračování',
  loginName: 'Jméno',
  loginPin: 'PIN',
  loginSubmit: 'Přihlásit se',
  loginPending: 'Přihlašuji…',
  loginErrEmpty: 'Vyplň jméno a PIN.',
  loginErrFailed: 'Přihlášení se nepodařilo.',

  // skenování
  scanTitle: 'Skenování kódu',
  scanHint: 'Namiř kameru na QR nebo čárový kód.',
  scanStart: 'Spustit skener',
  scanStop: 'Zastavit skener',
  scanStarting: 'Spouštím kameru…',
  scanCameraErr: 'Nepodařilo se spustit kameru.',
  scanLoading: 'Načítám informace o zásilce…',
  manualTitle: 'Nebo zadej kód ručně',
  manualPh: 'Číslo zásilky',
  manualSubmit: 'Vyhledat',

  // obecné chyby a stavy
  errLoad: 'Nepodařilo se načíst zásilku.',
  retryAction: 'Zkusit znovu',
  offline: 'Offline – zobrazená data nemusí být aktuální',
  queued: 'Odešle se po připojení',
  queueFailed: 'Nepodařilo se odeslat',
  sendErr: 'Nepodařilo se odeslat – zkusit znovu',

  // oprava váhy
  weightTitle: 'Oprava váhy',
  weightNew: 'Nová váha (kg)',
  weightPh: 'Např. 15,5',
  weightPhotos: 'Fotky (důkaz)',
  weightHint: 'Zadej skutečnou váhu a přilož fotky jako důkaz.',
  weightSave: 'Uložit váhu',
  errWeight: 'Zadej platnou váhu.',

  // přehled tras (role MASTER)
  routesEntry: 'Přehled tras',
  routesTitle: 'Trasy',
  routeTitle: 'Trasa',
  routesLoading: 'Načítám trasy…',
  routesErr: 'Nepodařilo se načíst trasy.',
  routesForbidden: 'Na přehled tras nemáš oprávnění.',
  routesEmpty: 'Pro tento den nejsou žádné trasy.',
  routesDay: 'Den',
  routesToday: 'Dnes',
  routesMine: 'Moje trasa',
  routesUnfinishedOnly: 'Jen nedokončené',
  routesAll: 'Vše',
  routesUnfinishedCount: 'Nedokončené',
  routeShipments: 'Zásilek',
  routeParcels: 'Balíků',
  routeLoaded: 'Naloženo',
  routeScanned: 'Naskenováno',
  routeNoDriver: 'Bez řidiče',
  routeBack: 'Zpět na trasy',
  routeErr: 'Nepodařilo se načíst trasu.',
  routeAllDone: 'Celá trasa je naložená.',
  routeToLoad: 'Zbývá naložit',
  routeUnseen: 'Nenaskenováno',
  routeNoUnfinished: 'Žádná nedokončená zásilka.',
  partialTitle: 'Rozskenované zásilky',
  partialNoRoute: 'Bez trasy',
  partialLoading: 'Načítám rozskenované zásilky…',
  partialBack: 'Zpět na sken',
  partialHint: 'Objednávky, u kterých je naskenovaná jen část balíků. Dohledej chybějící kusy a naskenuj je.',
  partialEmpty: 'Žádná rozskenovaná zásilka.',
  partialErr: 'Nepodařilo se načíst rozskenované zásilky.',
  shSender: 'Odesílatel',
  'sh.loaded': 'NALOŽENO',
  'sh.notLoaded': 'NASKENOVÁNO, NENALOŽENO',
  'sh.incomplete': 'NENASKENOVÁNO A NENALOŽENO',
  'sh.unknown': 'NEZNÁMÝ STAV',
  shMissing: 'Chybí balíky',

  // stavy: kicker / název / headline / popis
  's.preprava.kicker': 'V pořádku',
  's.preprava.name': 'Přeprava',
  's.preprava.headline': '',
  's.preprava.sub': 'Zásilka je v přepravě podle plánu.',

  's.schvaleni.kicker': 'Čeká na schválení',
  's.schvaleni.name': 'Schválení Přepravy',
  's.schvaleni.headline': 'ZÍTRA NEJEDE',
  's.schvaleni.sub':
    'Přeprava není schválená, zásilka ještě nemá jasný den doručení. Zásilku nedávej na zítřejší trasu.',

  's.priprava.kicker': 'Probíhá · příprava',
  's.priprava.name': 'Příprava Zásilky',
  's.priprava.headline': '',
  's.priprava.sub': 'Zásilka zítra nejede, bude pravděpodobně doručována.',

  's.vraceni.kicker': 'Pojede později · vracíme zpět',
  's.vraceni.name': 'Vrácení Odesilateli',
  's.vraceni.headline': '',
  's.vraceni.sub':
    'Zásilka zítra nejede, bude pravděpodobně doručována. Není to konečný stav.',

  's.dokoncena.kicker': 'Konečný stav · nahlas dispečink',
  's.dokoncena.name': 'Dokončená',
  's.dokoncena.headline': 'CHYBA ZÁSILKY',
  's.dokoncena.sub': 'Objednávka je již v konečném stavu – nahlas dispečerům.',

  's.zrusena.kicker': 'Konečný stav · nahlas dispečink',
  's.zrusena.name': 'Zrušená',
  's.zrusena.headline': 'CHYBA ZÁSILKY',
  's.zrusena.sub': 'Objednávka je již v konečném stavu – nahlas dispečerům.',

  's.vraceno.kicker': 'Konečný stav · nahlas dispečink',
  's.vraceno.name': 'Vráceno Odesilateli',
  's.vraceno.headline': 'CHYBA ZÁSILKY',
  's.vraceno.sub': 'Objednávka je již v konečném stavu – nahlas dispečerům.',

  's.nenalezena.kicker': 'Kód není v systému',
  's.nenalezena.name': 'Zásilka nenalezena',
  's.nenalezena.headline': 'ZÁSILKA NENALEZENA',
  's.nenalezena.sub': 'Naskenovaný kód se v systému nenašel.',

  's.neznamy.kicker': 'Nerozpoznáno · ověř',
  's.neznamy.name': 'Neznámý stav',
  's.neznamy.headline': '',
  's.neznamy.sub': 'Tento stav aplikace nezná. Nepokračuj bez ověření u dispečera.',
} as const;
